/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { SEND_EMAIL_URL_NODE, SEND_EMAIL_URL_PHP } from "../../config/api";
import { useTranslation } from "react-i18next";

const ContactForm = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Form verilerini kontrol et
      if (!formData.name || !formData.email || !formData.subject || !formData.message) {
        alert(t("Lütfen tüm zorunlu alanları doldurun!"));
        setIsLoading(false);
        return;
      }

      const response = await fetch(SEND_EMAIL_URL_NODE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const ct = response.headers.get('content-type') || '';
      if (response.ok && ct.includes('application/json')) {
        const result = await response.json();
        if (result && result.success) {
          alert(t("Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız."));
          setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
        } else {
          const msg = (result && result.error) ? result.error : 'unknown';
          throw new Error(msg);
        }
      } else {
        const text = await response.text();
        // Node yanıtı uygun değilse ve prod'da PHP mevcutsa fallback dene
        if (SEND_EMAIL_URL_PHP) {
          const phpRes = await fetch(SEND_EMAIL_URL_PHP, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
          });
          const phpCt = phpRes.headers.get('content-type') || '';
          if (phpRes.ok && phpCt.includes('application/json')) {
            const phpData = await phpRes.json();
            if (phpData && phpData.message) {
              alert(t("Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız."));
              setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
              return;
            }
          }
        }
        throw new Error(text.slice(0, 200) || 'Server hatası');
      }

    } catch (error) {
      console.error('Email error:', error);
      alert(t("Email gönderilirken bir hata oluştu! Lütfen tekrar deneyin."));
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <section className="contact-page section-space-top">
        <div className="container">
          <div className="contact-page__wrapper">
            <div className="contact-page__content">
              <div className="contact-page__sec-title">
                <h2 className="contact-page__title">İletişim</h2>
                <p
                  className="contact-info__text contact-info__text--business-hours"
                  style={{
                    color: "#111117",
                  }}
                >
                  Soru, görüş, öneri ve istekleriniz için aşağıdaki bilgiler
                  aracılığıyla bize 7/24 ulaşabilirsiniz .
                </p>
              </div>
              <form
                onSubmit={sendEmail}
                className="contact-page__form contact-form-validated form-one"
              >
                <div className="form-one__group">
                  <div
                    className="form-one__control wow fadeInUp"
                    data-wow-duration="1500ms"
                    data-wow-delay="00ms"
                  >
                    <input 
                      type="text" 
                      placeholder={t("Adınız")} 
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div
                    className="form-one__control wow fadeInUp"
                    data-wow-duration="1500ms"
                    data-wow-delay="50ms"
                  >
                    <input 
                      type="email" 
                      placeholder={t("Email")} 
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div
                    className="form-one__control wow fadeInUp"
                    data-wow-duration="1500ms"
                    data-wow-delay="00ms"
                  >
                    <input 
                      type="text" 
                      placeholder={t("Gsm")} 
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div
                    className="form-one__control wow fadeInUp"
                    data-wow-duration="1500ms"
                    data-wow-delay="50ms"
                  >
                    <input 
                      type="text" 
                      placeholder={t("Konu")} 
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div
                    className="form-one__control form-one__control--full wow fadeInUp"
                    data-wow-duration="1500ms"
                    data-wow-delay="100ms"
                  >
                    <textarea
                      name="message"
                      placeholder={t("Mesajınız")}
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                    ></textarea>
                  </div>
                  <div
                    className="form-one__control form-one__control--full wow fadeInUp"
                    data-wow-duration="1500ms"
                    data-wow-delay="150ms"
                  >
                    <button type="submit" className="boskery-btn" disabled={isLoading}>
                      <span className="boskery-btn__hover"></span>
                      <span className="boskery-btn__hover"></span>
                      <span className="boskery-btn__hover"></span>
                      <span className="boskery-btn__hover"></span>
                      <span className="boskery-btn__hover"></span>
                      <span className="boskery-btn__hover"></span>
                      <span className="boskery-btn__text">
                        {isLoading ? t("Gönderiliyor...") : t("Gönder")}
                      </span>
                      <i className="icon-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </form>
              <div className="result"></div>
            </div>
            <div
              className="contact-page__image wow fadeInRight"
              data-wow-duration="1500ms"
            >
              <img
                src="assets/images/iletisim/form.webp"
                alt="contact"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactForm;
